import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AccountInfo, RedirectRequest } from '@azure/msal-browser';

@Injectable({ providedIn: 'root' })
export class MSALAuthService {
  private accessToken: string;

  constructor(
    private router: Router,
    private msalAuthService: MsalService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
  ) {}

  isAuthenticated(): boolean {
    return this.msalAuthService.instance.getAllAccounts().length > 0;
  }

  logout(): void {
    this.msalAuthService.logout();
  }

  login(): void {
    const authRequest = this.msalGuardConfig.authRequest;
    const loginRequest = {
      ...(typeof authRequest === 'function' ? {} : authRequest || {}),
      prompt: 'login',
      redirectStartPage: '/orders',
    } as RedirectRequest;

    this.msalAuthService.loginRedirect(loginRequest).subscribe();
  }

  public setAccessToken(token: string): void {
    this.accessToken = token;
  }

  public getAccessToken(): string {
    return this.accessToken;
  }

  public getUserInfo(): AccountInfo {
    const activeAccount = this.msalAuthService.instance.getActiveAccount();
    return activeAccount;
  }
}
